<div class="card w-100">
  <div class="card-header background-card-header">
    <span class="h5" style="color: white;">ARCHIVIO BOLLETTINI METEO</span>
  </div>
  <div class="card-body d-flex flex-column justify-content-center"
    style="min-height: 50px; margin-top:20px; padding-top: 10px;">
    <div class="row px-3 d-flex flex-column">
      <div class="col-lg-4 col-md-6 col-sm-12 form-group d-flex flex-column">
        <label class="label-estrazione" for="select-anno">Anno</label>
        <select class="form-control" id="select-anno" aria-label="Seleziona anno" *ngIf="showYearSelect"
          [(ngModel)]="annoSelezione" (change)="onSelectChange($event)">
          <option *ngFor="let element of yearSelect;  let i = index;" value="{{element}}">{{element}}</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 py-2">
        <span (click)="switchOpen()" style="cursor: pointer;">Filtri periodo <i *ngIf="!openFilters" id="arrow-r"
            class="fa-solid fa-caret-right"></i><i *ngIf="openFilters" id="arrow-u"
            class="fa-solid fa-caret-down"></i></span>
      </div>
      <div *ngIf="openFilters" id="filtri-periodo" class="w-100 d-flex row">
        <div class="datepicker-container col-md-4 col-sm-12">
          <div class="form-group">
            <label for="dataDa" class="label-estrazione">Data da</label>
            <div class="pr-md-2 pr-sm-0">
              <input id="dataDa" class="form-control datetimepicker" placeholder="Seleziona una data" name="dp"
                ngbDatepicker #dp1="ngbDatepicker" [(ngModel)]="dataDa" (click)="dp1.toggle()"
                (ngModelChange)="isErroreDataDa = false" [maxDate]="today"
                [ngClass]="{'is-invalid': isErroreDataDa}" />
            </div>
          </div>
        </div>
        <div class="datepicker-container col-md-4 col-sm-12">
          <div class="form-group">
            <label for="dataA" class="label-estrazione">Data a</label>
            <div class="pl-md-2 pl-sm-0">
              <input id="dataA" class="form-control datetimepicker" placeholder="Seleziona una data" name="dp2"
                ngbDatepicker #dp2="ngbDatepicker" [(ngModel)]="dataA" (click)="dp2.toggle()"
                (ngModelChange)="isErroreDataA = false" [maxDate]="today"
                [ngClass]="{'is-invalid': isErroreDataA}" />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-end">
          <button class="btn btn-primary" (click)="findBollettiniPeriodo()"><i
              class="fa-solid fa-arrow-right"></i></button>
          <button class="btn btn-danger" (click)="resetBollettini()"><i class="fa-solid fa-trash"></i></button>
        </div>
      </div>
    </div>

    <div class="mt-3 border-radius-15 overflow-hidden">
      <ag-grid-angular [rowData]="data" [gridOptions]="gridOptions" style="height: 63vh; width: 100%;"
        class="ag-theme-alpine" [localeText]="customLocaleText">
      </ag-grid-angular>
    </div>
    <!-- <div class="mt-3 border-radius-15 overflow-hidden" *ngIf="gridServerOptions">
            <ag-grid-angular
                [gridOptions]="gridServerOptions"
                (paginationChanged)="onPaginationChanged($event)"
                style="height: 600px; width: 100%"
                class="ag-theme-alpine"
            ></ag-grid-angular>
        </div> -->

  </div>
</div>

<ng-template #theModalDettaglio let-modal let-c="close" let-d="dismiss">
  <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
    <span class="h4 m-0" style="float: left; margin-top: 10px;">BOLLETTINO </span>
    <button type="button" class="close" (click)="closeSingleModal(modal)">
      <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
    </button>
  </div>
  <div class="modal-body border-bottom">
    <div *ngIf="modelPdf ;else noPdf" class="w-100 py-2">
      <object [attr.data]="modelPdf" type="application/pdf" style="width: 100%; height: 800px; margin-top: -20px; margin-bottom: -20px;">
        
      </object>
    </div>
    <div class="w-100 py-2">

    </div>
  </div>
  <div class=" pt-3 modal-footer d-flex justify-content-end">
    <button class="btn btn-danger" (click)="closeSingleModal(modal)">
      <span class="h5">Chiudi</span>
    </button>
  </div>
</ng-template>

<ng-template #noPdf>
  <div class="w-75 d-flex justify-content-center">
    <span class="h5 w-100">Non è stato possibile visualizzare il file.</span>
  </div>
</ng-template>

<ng-template #errorModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Errore</h4>
    <button type="button" class="close" (click)="closeSingleModal(modal)">
      <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Si è verificato un errore durante il download del PDF. Riprova più tardi.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Chiudi</button>
  </div>
</ng-template>